export default __webpack_public_path__ + "static/media/depop.3e1b7daf.svg";